import base from '@/http/url_base';

export default {
  HABILITATION: base.API_COMPTE + '/mes-habilitations',
};
